import Vue from 'vue';

Vue.component('paginate', () => import('vue-pagination-2'));